/* El Ropero de la Anita — clean titles for catalog cards only. Shopify product titles stay unchanged. */
(function(){
 'use strict';
 var sizeRe=/\bTALLA(?:\s+EN\s+ETIQUETA)?\s*:?\s*(?:(?:APROX(?:IMADA)?|EUR|EU)\.?\s*)?(W\s*\d{1,3}\s+L\s*\d{1,3}|[A-Z0-9]+(?:[.,xX\/-][A-Z0-9]+)*)(?:\s*\(\s*\d{1,2}\s*\/\s*\d{1,2}\s*\))?/i;
 var tones=[
 [/azul\s+marino|navy/,'Azul marino','#172C4D','azul'],
 [/azul\s+oscuro/,'Azul oscuro','#263C64','azul'],
 [/turquesa/,'Turquesa','#35A8B3','turquesa'],
 [/celeste/,'Celeste','#91D0ED','celeste'],
 [/gris\s+oscuro|grafito/,'Gris oscuro','#4D535C','gris'],
 [/gris\s+claro/,'Gris claro','#B3B6B9','gris'],
 [/gris\s+jaspeado/,'Gris jaspeado','#858B94','gris'],
 [/verde\s+oliva/,'Verde oliva','#777C4C','verde'],
 [/verde\s+musgo/,'Verde musgo','#667A57','verde'],
 [/verde\s+menta/,'Verde menta','#A7D8BE','verde'],
 [/negro|negra/,'Negro','#1B1C20','negro'],
 [/blanco|blanca/,'Blanco','#FFFFFF','blanco'],
 [/beige/,'Beige','#CBB99C','beige'],[/camel/,'Camel','#B78B59','camel'],
 [/crema|marfil/,'Crema','#F2E4CD','crema'],[/cafe|marron/,'Café','#77513D','cafe'],
 [/burdeo|borgona|vino/,'Burdeo','#752F42','burdeo'],
 [/fucsia/,'Fucsia','#D92F87','fucsia'],[/rosado|rosada|rosa/,'Rosado','#E4A5AF','rosado'],
 [/rojo|roja|carmesi/,'Rojo','#CB3C43','rojo'],
 [/mostaza/,'Mostaza','#C59C37','mostaza'],
 [/naranja|naranjo|coral/,'Naranja','#E77E48','naranja'],
 [/amarillo|amarilla/,'Amarillo','#E7C947','amarillo'],
 [/morado|morada|violeta/,'Morado','#7B559C','morado'],
 [/lila/,'Lila','#A58AC9','lila'],[/terracota/,'Terracota','#B96D56','terracota'],
 [/gris/,'Gris','#858B94','gris'],[/azul/,'Azul','#386BC2','azul'],
 [/verde/,'Verde','#458367','verde']
 ];
 var erase=[
 ['azul\\s+marino','azul marino'],['azul\\s+oscuro','azul oscuro'],
 ['gris\\s+(?:oscuro|claro|jaspeado)','gris'],['verde\\s+(?:oliva|musgo|menta)','verde'],
 ['blanc[oa]s?','blanc'],['negr[oa]s?','negr'],['roj[oa]s?','roj'],
 ['rosad[oa]s?','rosad'],['turquesa','turquesa'],['celeste','celeste'],
 ['fucsia','fucsia'],['mostaza','mostaza'],['burdeo','burdeo'],
 ['beige','beige'],['camel','camel'],['caf[eé]','cafe'],['crema','crema'],
 ['gris','gris'],['azul','azul'],['verde','verde'],
 ['morad[oa]s?','morad'],['lila','lila'],['naranj[oa]s?','naranj'],
 ['amarill[oa]s?','amarill'],['terracota','terracota']
 ];
 function norm(s){return(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');}
 function colors(s){
  var source=norm(s),hits=[],groups={};
  tones.forEach(function(t){
   var m=source.match(t[0]);
   if(m&&!groups[t[3]]){groups[t[3]]=true;hits.push({at:m.index,name:t[1],hex:t[2]});}
  });
  return hits.sort(function(a,b){return a.at-b.at;}).slice(0,3);
 }
 function sizeOf(name,recorded){
  var m=name.match(sizeRe);
  if(m&&m[1])return m[1].trim();
  return(recorded||'').trim().replace(/\s*\(.+$/,'').slice(0,18);
 }
 function tidy(original,size,color,hits){
  var s=original.replace(sizeRe,' ');
  if(size&&/^[A-Z0-9.,\/\- ]{1,15}$/i.test(size)){
   var safe=size.replace(/[-/\\^$*+?.()|[\]{}]/g,'\\$&').replace(/\s+/g,'\\s+');
   s=s.replace(new RegExp('(^|[\\s·,|])'+safe+'(?=$|[\\s·,|])','gi'),'$1 ');
  }
  if(hits.length){
   var c=norm(color);
   erase.forEach(function(e){
    if(!(new RegExp(e[1],'i')).test(c))return;
    s=s.replace(new RegExp('(^|[^a-zA-ZÁÉÍÓÚÜÑáéíóúüñ0-9])(?:'+e[0]+')(?![a-zA-ZÁÉÍÓÚÜÑáéíóúüñ0-9])','gi'),'$1 ');
   });
  }
  s=s.replace(/\s+[/·|,–—]\s+/g,' ').replace(/(?:^|\s+)y(?=\s|$)/gi,' ')
   .replace(/(?:\s+con\s+detalles)\s*$/i,'').replace(/(?:\s+color)\s*$/i,'')
   .replace(/[\s·|/,\-]+$/g,'').replace(/\s+/g,' ').trim();
  return s.length>7?s:original;
 }
 function decorate(card){
  if(card.dataset.anitaDone==='yes')return;
  card.dataset.anitaDone='yes';
  var heading=card.querySelector('.card > .card__content > .card__information > .card__heading');
  var link=heading&&heading.querySelector('a.full-unstyled-link');
  if(!link)return;
  var original=link.textContent.replace(/\s+/g,' ').trim();
  var size=sizeOf(original,card.dataset.anitaSize||'');
  var color=card.dataset.anitaColor||'';
  if(!color){var fallback=colors(original);if(fallback.length)color=fallback.map(function(v){return v.name;}).join(' / ');}
  if(!color){var introTones=colors(card.dataset.anitaIntro||'');if(introTones.length)color=introTones.map(function(c){return c.name;}).join(' / ');}
  var hits=colors(color),cleaned=tidy(original,size,color,hits);
  if(cleaned!==original)link.textContent=cleaned;
  if(!size&&!hits.length)return;
  var line=document.createElement('div');line.className='anita-card-details';
  if(size){var b=document.createElement('span');b.className='anita-card-details__size';b.textContent='Talla '+size;line.appendChild(b);}
  if(hits.length){
   var box=document.createElement('span'),dot=document.createElement('span'),label=document.createElement('span');
   box.className='anita-card-details__color';dot.className='anita-card-details__dot';
   dot.setAttribute('aria-hidden','true');
   dot.style.background=hits.length===1?hits[0].hex:'conic-gradient('+hits.map(function(v,i){
    return v.hex+' '+Math.round(i*100/hits.length)+'% '+Math.round((i+1)*100/hits.length)+'%';
   }).join(',')+')';
   label.className='anita-card-details__name';label.textContent=hits.map(function(v){return v.name;}).join(' / ');
   box.title='Color de la prenda: '+color;box.append(dot,label);line.appendChild(box);
  }
  heading.insertAdjacentElement('afterend',line);
 }
 function scan(){document.querySelectorAll('[data-anita-catalog-card]:not([data-anita-done="yes"])').forEach(decorate);}
 var queue=false;function requestScan(){if(queue)return;queue=true;requestAnimationFrame(function(){queue=false;scan();});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
 document.addEventListener('shopify:section:load',requestScan);
 var root=document.getElementById('MainContent')||document.body;
 new MutationObserver(function(m){if(m.some(function(x){return x.addedNodes&&x.addedNodes.length>0;}))requestScan();})
  .observe(root,{childList:true,subtree:true});
})();
